import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import BillingOutcomeLayout from "@/domains/billing/components/BillingOutcomeLayout";
import { useAppContext } from "@/app/providers/AppContext";
import confetti from "canvas-confetti"; // Optional: For a bit of 'vibe'

const BillingSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const { loadProfile, profile } = useAppContext();

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (sessionId) {
      loadProfile();
      // Trigger a subtle celebration
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        colors: ["#0062ff", "#000000", "#ffffff"], // Brand colors
      });
    }
  }, [searchParams, loadProfile]);

  // Derive the plan name without an extra state/effect
  const planDisplayName = useMemo(() => {
    if (!profile?.plan) return "Processing...";
    return profile.plan
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c: string) => c.toUpperCase());
  }, [profile?.plan]);

  return (
    <BillingOutcomeLayout
      status="success"
      eyebrow="Transaction Confirmed"
      title="Access Granted"
      description={
        <div className="space-y-4">
          <p>
            Your subscription to <strong>{planDisplayName}</strong> is now
            active.
          </p>
        </div>
      }
      detail="A copy of your receipt has been sent to your registered email address. Your workspace features have been updated automatically."
      planName={planDisplayName}
      ctaLabel="Enter Dashboard"
      ctaTo="/portal"
      secondaryLabel="View Invoices"
      secondaryTo="/portal/billing"
    />
  );
};

export default BillingSuccessPage;
